export const TEAMS = 'TEAMS';
export const FETCH_USER_TEAMS = `${TEAMS}/FETCH_USER_TEAMS`;
